import {AutogenLayoutTableCashAdvanceHistory} from "./AutogenLayoutTableCashAdvanceHistory";

export class TableCashAdvanceHistory extends AutogenLayoutTableCashAdvanceHistory {

}
